export const NETLOSS_LIMIT_80_ID = "netloss-limit-80";
